/**
 * Which layout an inspection of the disposition shows for the unit data ("Anlagendaten"): the escalator layout
 * (icon `mdi-escalator`, escalator specification `elevator.escalator`, HCIT-934) or the elevator layout.
 *
 * The device type reported by the SmartLift app decides (HCIT-1191), because the escalator specification stays in the
 * backend when the type is changed from escalator to elevator in the app (HCIT-1190). Without a reported type (older
 * apps) the escalator data of the inspection decide, as before.
 *
 * Pure function without store or REST access, so it can be tested without a component.
 */
export default {
    isEscalator (inspection) {
        if (!inspection) {
            return false;
        }

        if (inspection.deviceType) {
            return inspection.deviceType === "ESCALATOR";
        }

        return !!inspection.elevator && !!inspection.elevator.escalator;
    },
};
